import afterFrame from 'afterframe'
import { Epic } from 'redux-observable'
import { empty } from 'rxjs'
import { filter, mergeMap, pluck } from 'rxjs/operators'
import { performanceTracking } from 'shared/store/actions/performanceTracking'

import { isActionOf, RootAction, RootState } from 'typesafe-actions'

export const performanceTrackingEpic: Epic<RootAction, RootAction, RootState> = (action$) =>
  action$.pipe(
    filter(isActionOf(performanceTracking)),
    pluck('payload'),
    mergeMap((payload) => {
      afterFrame(() => {
        payload.interaction.end()
      })
      return empty()
    })
  )
